"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getTagPositions_1 = __importDefault(require("./getTagPositions"));
const getTrueTagPosition = (text, cmPos) => {
    const positions = getTagPositions_1.default(text);
    return positions.find(p => cmPos.line === p.line && cmPos.ch >= p.start && cmPos.ch <= p.stop);
};
exports.default = getTrueTagPosition;
